import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
interface UseGetDistributionJobsGlDetailsProps {
  communityId: string;
  jobId: string;
  glMasterId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionJobsGlDetails = async (jobId: string, glMasterId: string, communityId: string) =>
  await axiosAuth.get(`${DISTRIBUTION_JOBS_API(communityId)}/${jobId}/gl/${glMasterId}/details`);

const useGetDistributionJobsGlDetails = ({
  queryParams,
  jobId,
  glMasterId,
  communityId
}: UseGetDistributionJobsGlDetailsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-jobs-gl-details", jobId, glMasterId],
    queryFn: () => getDistributionJobsGlDetails(jobId, glMasterId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!glMasterId && !!communityId && !!jobId && (queryParams?.enabled ?? true),
  });
};

export default useGetDistributionJobsGlDetails;
